module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh3"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CDS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("J. Bain (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Calendar of Documents relating to Scotland")]), _vm._v(", Vol. IV, 1357–1509, Edinburgh, 1881–8")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("De Fonblanque")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("E.B. De Fonblanque, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Annals of the House of Percy: From the Conquest to the opening of the nineteenth century")]), _vm._v(", London, R. Clay & Sons, 1887, Vol. 1")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("Froissart")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("Jean Froissart, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chronicles of England, France etc.")]), _vm._v(", trans. Lord Berners, ed. G.C. Macaulay, London, Macmillan & Co., 1924")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("Hardyng")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("J. Hardyng, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Chronicle of John Hardyng")]), _vm._v(", ed. F.C. and J. Rivington, England, 1812")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("Ridpath")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("G. Ridpath, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Border History of England and Scotland")]), _vm._v(", Edinburgh, Mercat Press, 1979")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Scotichronicon")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("Walter Bower, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scotichronicon")]), _vm._v(", ed. D.E.R. Watt, Edinburgh, John Donald, 2012, Vol. 7")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("Usk")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chronicles of Adam of Usk 1377–1421")]), _vm._v(", trans. C. Given-Wilson, Oxford, Oxford Medieval Texts, 1997")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("Walsingham")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("Thomas Walsingham, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Historia Anglicana")]), _vm._v(", ed. H.T. Riley, Rolls Series, Cambridge Library, 2015")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-599ee5c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Abbreviations.vue
// module id = 90
// module chunks = 0